/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { Ref } from '@vue/composition-api';
import reportPlugin from '@tencent/iwan-act-report';
import UniversalReport from '@tencent/iwan-act-report/src/middleware/universal-report';
import { App } from '../../types';

const useReport = (app: App, pageName: Ref<string>, vm: any) => {
  if (vm.$magicReport) {
    new vm.$magicReport(vm);
  }

  const appid = app.boss?.f_magic_appid || 1;
  const cubeid = app.actId || app.id;
  const pageNameValue = `${pageName.value || 'index'}`;
  const fUrl = `/magic-act/${cubeid}/index.html/${pageNameValue}`;

  const universalReportMiddleware = new UniversalReport({
    pageId: `activity-${cubeid}-${pageNameValue}`,
    extraParams() {
      return {
        // vuserid: state.userInfo?.vuserid,
        magic_path: fUrl,
        magic_appid: appid,
        magic_cubeid: cubeid,
        ...vm.$magicReport?.instance?.datongCommonParams || {},
      };
    },
    delay: true,
    extraDefaultChannel: 'app',
    channel: () => ({
      init() {
        return true;
      },
      report(reportParam: any) {
        if (reportParam?.eventName === 'dt_pgin') {
          window.stageReport?.('on_dt_pgin');
        }
      },
      on() {},
    }),
  });

  // 对大同上报内的调用进行追踪并且上报到的链路
  universalReportMiddleware.onTrack?.((trackEvent) => {
    window.stageReport?.(trackEvent);
  });

  Vue.use(reportPlugin, {
    vm,
    middlewares: [
      universalReportMiddleware,
    ],
    delay: true,
    silent: false,
  });
  window.stageReport?.('on_page_meaningful_view');
  Vue.prototype.$report.ready();
};

export default useReport;
